import React from 'react'
import { PanelToggle } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { customStyleState, pageState } from '../recoil/state/state'
import { enableAllCallback } from '../recoil/callbacks/callbacks'
import { pendoTrack } from 'Helpers/pendoTracking'

const State = () => {
  const intl = useIntl()
  const [{ enabledAll }, setCustomStyleState] = useRecoilState(customStyleState)

  const { isEnabled } = useRecoilValue(pageState)
  const enableAll = useRecoilCallback(enableAllCallback, [])
  const handleOnChangeToggle = e => {
    pendoTrack('Content Defaults - Activation/Deactivation', {
      value: !enabledAll
    })
    setCustomStyleState(prev => ({
      ...prev,
      enabledAll: !enabledAll
    }))

    enableAll(!enabledAll)
  }

  return (
    <>
      <PanelToggle
        title={intl.formatMessage({ id: 'Load.ContentDefaults.Toggle' })}
        onChange={handleOnChangeToggle}
        checked={enabledAll}
        titleVariant='S'
        disabled={!isEnabled}
        data-mu-test='content-defaults'
      />
    </>
  )
}

export default State
